import { Box } from '@mui/material';
import React, { FC } from 'react';

const ForbiddenPage: FC = () => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			paddingTop: '15%',
		}}
	>
		403 ERROR: FORBIDDEN
	</Box>
);

export default ForbiddenPage;
